import { ReactElement } from 'react';
import styles from './ui-avatar.module.scss';
import { UITooltip } from '../..';

export type UISubAvatarProps = {
    img: string;
    alt: string;
};

export type UIAvatarProps = {
    img: string;
    alt: string;
    subAvatar?: UISubAvatarProps;
    size?: number;
};
export function UIAvatar(props: UIAvatarProps): ReactElement {
    const { img, alt, subAvatar, size = 35 } = props;

    const _subImgSize = size / 2;
    const _subImgOffset = _subImgSize / 8;

    return (
        <div style={{ position: 'relative', width: size, height: size }}>
            <img
                src={img}
                alt={alt}
                className={styles.avatar}
                style={{ width: size, height: size, borderRadius: size / 5 }}
            />

            {subAvatar && (
                <UITooltip text={subAvatar.alt}>
                    <img
                        src={subAvatar.img}
                        alt={subAvatar.alt}
                        className={styles.avatar}
                        style={{
                            position: 'absolute',
                            bottom: -_subImgOffset,
                            right: -_subImgOffset,
                            width: _subImgSize,
                            height: _subImgSize,
                            boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.25)',
                            objectFit: 'cover',
                            borderRadius: _subImgSize / 4
                        }}
                    />
                </UITooltip>
            )}
        </div>
    );
}
